// TODO: após clonar o skeleton, ajustar os links de ambientes

const dev = {
	API_ENDPOINT_URL: "http://localhost:8095/senda-account/api",
	PUBLIC_PREFIX_PATH: "",
	API_CORE_ENDPOINT_URL: "http://localhost:8080/core/api",
	API_URL: "http://localhost:8095",
};

const prod = {
	API_ENDPOINT_URL: "https://senda-back-66use.ondigitalocean.app/senda-back2/senda-back/senda-account/api",
	PUBLIC_PREFIX_PATH: "",
	API_CORE_ENDPOINT_URL: "http://34.220.116.233:8080/core/api",
	API_URL: "http://34.220.116.233:8095",
};

const test = {
	API_ENDPOINT_URL:
		"https://homolog.dimo.com.br/senda-back/senda-account/api",
	PUBLIC_PREFIX_PATH: "/senda",
	API_CORE_ENDPOINT_URL: "http://34.220.116.233:8080/core/api",
	API_URL: "https://homolog.dimo.com.br/senda-back",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
